var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "svg",
    {
      attrs: {
        width: _vm.size,
        height: _vm.size,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg"
      }
    },
    [
      _c("rect", {
        attrs: { x: "6", y: "6", width: "11", height: "11", fill: _vm.color }
      }),
      _c("path", {
        attrs: {
          d:
            "M18.5408 4.17001L13.0408 2.11001C12.4708 1.90001 11.5408 1.90001 10.9708 2.11001L5.47078 4.17001C4.41078 4.57001 3.55078 5.81001 3.55078 6.94001V15.04C3.55078 15.85 4.08078 16.92 4.73078 17.4L10.2308 21.51C11.2008 22.24 12.7908 22.24 13.7608 21.51L19.2608 17.4C19.9108 16.91 20.4408 15.85 20.4408 15.04V6.94001C20.4508 5.81001 19.5908 4.57001 18.5408 4.17001ZM12.0008 16.25C9.38078 16.25 7.25078 14.12 7.25078 11.5C7.25078 8.88001 9.38078 6.75001 12.0008 6.75001C14.6208 6.75001 16.7508 8.88001 16.7508 11.5C16.7508 14.12 14.6208 16.25 12.0008 16.25Z",
          fill: _vm.color
        }
      }),
      _c("path", {
        attrs: {
          "fill-rule": "evenodd",
          "clip-rule": "evenodd",
          d:
            "M10.7951 12.2115L12.4871 11.5275L13.2011 9.7855L11.5091 10.4695L10.7951 12.2115ZM15.9235 8.4185L14.1775 12.6765C14.0755 12.9265 13.8775 13.1235 13.6275 13.2255L9.41452 14.9265C9.29152 14.9755 9.16452 14.9985 9.04052 14.9985C8.76952 14.9985 8.51552 14.8815 8.32752 14.6885C8.30952 14.6715 8.29052 14.6575 8.27352 14.6405C8.26452 14.6295 8.25852 14.6165 8.25052 14.6055C8.01252 14.3295 7.92452 13.9395 8.07252 13.5785L9.81852 9.3205C9.92052 9.0705 10.1195 8.8735 10.3695 8.7725L14.5825 7.0705C14.9765 6.9145 15.4075 7.0265 15.6815 7.3165C15.9725 7.5925 16.0845 8.0245 15.9235 8.4185Z",
          fill: "white"
        }
      })
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }